module.exports = __webpack_public_path__ + "img/CIMG1150.c8417c3c.jpg";